import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';

export default function ServiceCard({ icon, title, description, link, background }) {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: 2,
        ...(background && {
          backgroundImage: `linear-gradient(rgba(10,16,30,0.7), rgba(24,45,70,0.7)), url(${background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'common.white',
        }),
      }}
      elevation={3}
    >
      <CardContent>
        <Box sx={{ fontSize: 56, color: 'secondary.main', mb: 1 }}>{icon}</Box>
        <Typography variant="h5" component="h3" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" paragraph>
          {description}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          component={Link}
          to={link}
          size="small"
          color="secondary"
          variant="contained"
        >
          Learn more: {title}
        </Button>
      </CardActions>
    </Card>
  );
}
